import React from "react";
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import Done from "@material-ui/icons/Done";
import SwitchOnKitSectionHeader from "../SwitchOnKitItemBuilder/SwitchOnKitSectionHeader";

const COLOUR_CODES = ["AB_CABLE_COLOUR", "AB_CAP_COLOUR"];
const splitOptions = (value) => (value || "").split("|").filter(Boolean);

const WaterproofSolutionColours = ({ rightSelected, leftSelected, linked, setLinked, getOptionsForSide, selectedOptions, setOption, configurationGroupRight, configurationGroupLeft }) => {
  const renderSide = (side) => getOptionsForSide(side)
    .filter((option) => COLOUR_CODES.includes(option.Code))
    .sort((a, b) => COLOUR_CODES.indexOf(a.Code) - COLOUR_CODES.indexOf(b.Code))
    .map((option) => {
      const selected = selectedOptions[side][option.Name];
      const configuration = side === "R" ? configurationGroupRight : configurationGroupLeft;
      const source = option.Code === "AB_CABLE_COLOUR"
        ? (configuration && configuration.ShellColours) || []
        : (configuration && configuration.FaceplateColours) || [];
      const order = splitOptions(option.Options).map((value) => value.split("-").pop().trim());
      const colours = source.slice().sort((a, b) => order.indexOf(a.Code) - order.indexOf(b.Code));
      const active = colours.find((colour) => colour.Code === selected);
      return <Row className={side === "R" ? "ite-shell-colour-row-right" : "ite-shell-colour-row-left"} key={`${side}-${option.Code}`}>
        <Col xs={12}><p>{option.Name}: {active && <strong>{active.Name} - {active.Code}</strong>}</p></Col>
        {colours.map((colour) => <Col key={colour.Code} xs={3}><button type="button" className="waterproof-colour-button" title={`${colour.Name} - ${colour.Code}`} onClick={() => setOption(side, option, colour.Code)}>
          <div className={`ite-shell-colour-box ${selected === colour.Code ? "active" : ""}`} style={colour.ImagePath ? { backgroundImage: `url('${colour.ImagePath}')`, backgroundSize: "contain" } : { backgroundColor: `rgb(${colour.Rgb})` }}>
            <div className="ite-shell-colour-box-text">{selected === colour.Code && <Done className="icon-shadow" />}</div>
          </div>
        </button></Col>)}
      </Row>;
    });

  return <div className="waterproof-colours ite-shell-colour-component-main-div order-builder-component">
    <SwitchOnKitSectionHeader title="Choose colours" rightSelected={rightSelected} leftSelected={leftSelected} linked={linked} setLinked={setLinked}>
      <Col md={6}>{rightSelected && renderSide("R")}</Col>
      <Col md={6} className="left-side">{leftSelected && renderSide("L")}</Col>
    </SwitchOnKitSectionHeader>
  </div>;
};

WaterproofSolutionColours.propTypes = {
  rightSelected: PropTypes.bool, leftSelected: PropTypes.bool, linked: PropTypes.bool,
  setLinked: PropTypes.func, getOptionsForSide: PropTypes.func,
  selectedOptions: PropTypes.object, setOption: PropTypes.func,
  configurationGroupRight: PropTypes.object, configurationGroupLeft: PropTypes.object,
};

export default WaterproofSolutionColours;
